export enum FirestoreEnum {
  APP_KEY_CONFIGS = 'appKeyConfigs',
  ARSENAL = 'arsenal',
  AEM = 'aem',
}
